// Severity levels by incident type (kept as-is for compatibility)
export const SEVERITY_SCALES = {
  eating_nutrition: {
    1: { label: "Slightly Picky", color: "#4CAF50", description: "Minor food preference" },
    2: { label: "Refused Some", color: "#66BB6A", description: "Skipped parts of meal" },
    3: { label: "Ate Very Little", color: "#8BC34A", description: "Minimal intake" },
    4: { label: "Refused Most", color: "#CDDC39", description: "Only ate favorites" },
    5: { label: "Barely Ate", color: "#8B5CF6", description: "Few bites only" },
    6: { label: "Refused All Food", color: "#FFB300", description: "No solid food intake" },
    7: { label: "Refused Everything", color: "#FF9800", description: "No food or drink" },
    8: { label: "Gagging/Vomiting", color: "#FF7043", description: "Physical rejection" },
    9: { label: "Choking Risk", color: "#F44336", description: "Safety concerns" },
    10: { label: "Medical Emergency", color: "#D32F2F", description: "Immediate help needed" },
  },
  mood: {
    1: { label: "Slightly Off", color: "#4CAF50", description: "Minor mood dip" },
    2: { label: "A Bit Sad", color: "#66BB6A", description: "Temporary sadness" },
    3: { label: "Noticeably Upset", color: "#8BC34A", description: "Visible mood change" },
    4: { label: "Quite Upset", color: "#CDDC39", description: "Affecting activities" },
    5: { label: "Very Distressed", color: "#8B5CF6", description: "Seeking comfort often" },
    6: { label: "Inconsolable", color: "#FFB300", description: "Hard to comfort" },
    7: { label: "Deeply Distressed", color: "#FF9800", description: "Major emotional pain" },
    8: { label: "Extreme Distress", color: "#FF7043", description: "Overwhelming emotions" },
    9: { label: "Crisis Level", color: "#F44336", description: "Urgent emotional support needed" },
    10: { label: "Emergency", color: "#D32F2F", description: "Immediate intervention required" },
  },
  sleep: {
    1: { label: "Slightly Restless", color: "#4CAF50", description: "Minor sleep disruption" },
    2: { label: "Took Longer", color: "#66BB6A", description: "Delayed sleep onset" },
    3: { label: "Woke Once", color: "#8BC34A", description: "Single wake-up" },
    4: { label: "Multiple Wakes", color: "#CDDC39", description: "Several disruptions" },
    5: { label: "Very Restless", color: "#8B5CF6", description: "Frequent stirring" },
    6: { label: "Barely Slept", color: "#FFB300", description: "Minimal sleep achieved" },
    7: { label: "No Sleep", color: "#FF9800", description: "Unable to fall asleep" },
    8: { label: "Night Terror", color: "#FF7043", description: "Extreme sleep disturbance" },
    9: { label: "Severe Insomnia", color: "#F44336", description: "Chronic sleep issues" },
    10: { label: "Medical Concern", color: "#D32F2F", description: "Professional help needed" },
  },
  behavioral: {
    1: { label: "Slightly Defiant", color: "#4CAF50", description: "Minor resistance" },
    2: { label: "Not Listening", color: "#66BB6A", description: "Ignoring instructions" },
    3: { label: "Acting Out", color: "#8BC34A", description: "Inappropriate behavior" },
    4: { label: "Disruptive", color: "#CDDC39", description: "Affecting others" },
    5: { label: "Very Difficult", color: "#8B5CF6", description: "Major behavior issues" },
    6: { label: "Tantrum", color: "#FFB300", description: "Emotional outburst" },
    7: { label: "Aggressive", color: "#FF9800", description: "Harmful behavior" },
    8: { label: "Destructive", color: "#FF7043", description: "Damaging property" },
    9: { label: "Dangerous", color: "#F44336", description: "Risk to self/others" },
    10: { label: "Crisis", color: "#D32F2F", description: "Immediate intervention needed" },
  },
  sensory: {
    1: { label: "Slight Sensitivity", color: "#4CAF50", description: "Minor sensory reaction" },
    2: { label: "Noticeable Discomfort", color: "#66BB6A", description: "Mild sensory issues" },
    3: { label: "Avoiding Stimuli", color: "#8BC34A", description: "Sensory avoidance" },
    4: { label: "Seeking Relief", color: "#CDDC39", description: "Actively avoiding triggers" },
    5: { label: "Distressed", color: "#8B5CF6", description: "Clear sensory distress" },
    6: { label: "Very Overwhelmed", color: "#FFB300", description: "Sensory overload" },
    7: { label: "Shutdown", color: "#FF9800", description: "Sensory system overwhelmed" },
    8: { label: "Meltdown", color: "#FF7043", description: "Complete sensory breakdown" },
    9: { label: "Severe Overload", color: "#F44336", description: "Extreme sensory crisis" },
    10: { label: "Emergency", color: "#D32F2F", description: "Immediate sensory intervention needed" },
  },
  pain_medical: {
    1: { label: "Mild Discomfort", color: "#4CAF50", description: "Barely noticeable" },
    2: { label: "Minor Pain", color: "#66BB6A", description: "Slight discomfort" },
    3: { label: "Noticeable Pain", color: "#8BC34A", description: "Can still play" },
    4: { label: "Moderate Pain", color: "#CDDC39", description: "Affecting some activities" },
    5: { label: "Uncomfortable", color: "#8B5CF6", description: "Seeking comfort often" },
    6: { label: "Significant Pain", color: "#FFB300", description: "Hard to ignore" },
    7: { label: "Severe Pain", color: "#FF9800", description: "Major impact on activities" },
    8: { label: "Intense Pain", color: "#FF7043", description: "Very distressing" },
    9: { label: "Extreme Pain", color: "#F44336", description: "Unable to function" },
    10: { label: "Excruciating", color: "#D32F2F", description: "Medical emergency" },
  },
  other: {
    1: { label: "Very Mild", color: "#4CAF50", description: "Barely noticeable" },
    2: { label: "Mild", color: "#66BB6A", description: "Minor concern" },
    3: { label: "Mild-Moderate", color: "#8BC34A", description: "Noticeable but manageable" },
    4: { label: "Moderate", color: "#CDDC39", description: "Some impact on activities" },
    5: { label: "Moderate-High", color: "#8B5CF6", description: "Moderate disruption" },
    6: { label: "High", color: "#FED7AA", description: "Significant impact" },
    7: { label: "High-Severe", color: "#FF9800", description: "Major disruption" },
    8: { label: "Severe", color: "#FF7043", description: "Serious concern" },
    9: { label: "Very Severe", color: "#F44336", description: "Urgent attention needed" },
    10: { label: "Critical", color: "#D32F2F", description: "Immediate action required" },
  },
};
